export interface Address {
  address1: string;
  address2: string;
  city: string;
  prefecture: string;
  zip: string;
}

export const AddressDefault: Address = {
  zip: "",
  prefecture: "",
  city: "",
  address1: "",
  address2: "",
} as const;
